export default "__VITE_ASSET__BAj$vnGu__"